import { PROPERTY_NAME, COL_PROPERTY_NAME } from "./field/property_name";
import { LISTING_SOURCE, COL_LISTING_SOURCE, COL_MODAL_LISTING_SOURCE } from "./field/listing_source";
import { LISTING_TYPE, COL_LISTING_TYPE, COL_MODAL_LISTING_TYPE } from "./field/listing_type";
import { PROPERTY_TYPE_GROUP, COL_PROPERTY_TYPE_GROUP, COL_MODAL_PROPERTY_TYPE_GROUP } from "./field/property_type_group";
import { PROPERTY_TYPE, COL_PROPERTY_TYPE, COL_MODAL_PROPERTY_TYPE } from "./field/property_type";
import { LOCATION, COL_LOCATION, COL_MODAL_LOCATION } from "./field/location";
import { TENURE, COL_TENURE, COL_MODAL_TENURE } from "./field/tenure";
import { BEDROOMS, COL_BEDROOMS, COL_MODAL_BEDROOMS } from "./field/bedrooms";
import { PRICE_MIN, PRICE_MAX, COL_PRICE_MIN, COL_PRICE_MAX, COL_MODAL_PRICE_MIN, COL_MODAL_PRICE_MAX } from "./field/price";
import { CLEAR_BUTTON, SUBMIT_BUTTON, COL_CLEAR_SUBMIT_BUTTON } from "./field/button";

const getSearchFields = () => {

  return [
    PROPERTY_NAME,
    LISTING_TYPE,
    PROPERTY_TYPE_GROUP,
    PROPERTY_TYPE,
    LOCATION,
    TENURE,
    BEDROOMS,
    PRICE_MIN,
    PRICE_MAX,
  ];

}

const getSearchFormConfig = ({ search_type }) => {

  const MOBILE_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        {
          id: "col",
          type: "col",
          props: {
            className: "",
          },
          children: [
            PROPERTY_NAME,
          ]
        },
        {
          id: "col_2",
          type: "col",
          props: {
            className: "d-flex align-items-center justify-content-end",
            xs: "auto",
            style: {
              width: 60
            }
          },
          children: [
            {
              id: "modal",
              type: "modal",
              children: [
                {
                  id: "container",
                  type: "container",
                  props: {
                    fluid: true,
                    className: "search-form d-flex flex-column gap-2"
                  },
                  children: [
                    {
                      id: "row_1",
                      type: "row",
                      props: {
                        className: "gy-2 d-flex flex-fill"
                      },
                      children: [
                        COL_MODAL_LISTING_TYPE,
                        COL_MODAL_PROPERTY_TYPE_GROUP,
                        COL_MODAL_PROPERTY_TYPE,
                        COL_MODAL_LOCATION,
                        COL_MODAL_TENURE,
                        COL_MODAL_BEDROOMS,
                      ]
                    },
                    {
                      id: "row_2",
                      type: "row",
                      props: {
                        className: "gy-2 d-flex flex-fill"
                      },
                      children: [
                        COL_MODAL_PRICE_MIN,
                        COL_MODAL_PRICE_MAX,
                      ]
                    },
                    {
                      id: "row_3",
                      type: "row",
                      props: {
                        className: "gy-2 d-flex flex-fill"
                      },
                      children: [
                        COL_CLEAR_SUBMIT_BUTTON
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ];

  const DESKTOP_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_PROPERTY_NAME,
        COL_LISTING_TYPE,
        COL_PROPERTY_TYPE_GROUP,
        COL_PROPERTY_TYPE,
        COL_LOCATION,
        COL_TENURE,
        COL_BEDROOMS,
        COL_PRICE_MIN,
        COL_PRICE_MAX,
      ]
    },
    {
      id: "row_2",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_CLEAR_SUBMIT_BUTTON
      ]
    }
  ];

  const MOBILE = {
    id: "mobile",
    type: "div",
    props: {
      className: "d-flex flex-column d-sm-none mobile"
    },
    children: MOBILE_FORM
  };

  const DESKTOP = {
    id: "desktop",
    type: "div",
    props: {
      className: "d-none d-sm-flex flex-column desktop"
    },
    children: DESKTOP_FORM
  };

  // TODO: Hook here

  if (search_type === "map") {
    return MOBILE_FORM;
  }

  return [{
    id: "form",
    type: "div",
    children: [
      MOBILE,
      DESKTOP
    ]
  }];

}

export { getSearchFields, getSearchFormConfig };
